import React from 'react';
import MessageQuestionIcon from '@icons/message-question-icon';
import { Button } from 'antd';
import { t } from 'i18next';

export function withErrorBoundary<P>(WrappedComponent: React.ComponentType<P>) {
  const fallback = () => (
    <div
      className="flex h-[38px] cursor-pointer items-center gap-[8px] border border-solid border-red-500 p-[6px]"
      onClick={() => {
        document.getElementById('feadback')?.click();
      }}
    >
      🤯{t('shaxmatka.Xatolik_mavjud')?.toString()}⚠️
      <Button size="small" className="flex items-center gap-[4px]">
        <MessageQuestionIcon className="size-[16px]" /> {t('global.Xabar_berish')?.toString()}
      </Button>
    </div>
  );

  if (typeof WrappedComponent === 'function') {
    class ErrorBoundaryWrapper extends React.Component<
      P,
      {
        hasError: boolean;
        componentStack: string;
      }
    > {
      // eslint-disable-next-line react/state-in-constructor
      state = { hasError: false, componentStack: '' };

      static getDerivedStateFromError(_: any) {
        return { hasError: true };
      }

      componentDidCatch(error: any, info: any) {
        this.state.componentStack = info?.componentStack;
        // eslint-disable-next-line no-console
        console.log('Component error:', error, info);
      }

      render() {
        if (this.state.hasError) return fallback();
        return <WrappedComponent {...this.props} />;
      }
    }

    return function WrappedWithErrorBoundary(props: P) {
      try {
        // @ts-expect-error
        return <ErrorBoundaryWrapper {...props} />;
      } catch {
        return fallback();
      }
    };
  }
  return WrappedComponent;
}
